import { render, staticRenderFns } from "./BrandItemDetail.vue?vue&type=template&id=405cc2b8&"
import script from "./BrandItemDetail.vue?vue&type=script&lang=js&"
export * from "./BrandItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports